import { printDate } from "../../../../utils/date.utils";
import Form from "../../../../ui/Form";
import Modal from "../../../../ui/Modal";

export default function VehicleInventoryPrintModal({
  modal,
  toggle,
  printDate: pd,
  handlePrint,
  modalTitle,
  modalType = ["money-receipt"]
}) {
  const isDate = modalType.includes("money-receipt");
  const fields = [
    ...(isDate
      ? [
          {
            label: "Print Date",
            name: "print_date",
            type: "date",
            placeholder: "Select a date",
            col: { md: 12 }
          }
        ]
      : []),
    {
      label: "Print With Pad?",
      name: "print_pad_type",
      type: "radio",
      col: { md: 6 },
      options: [
        {
          value: "1",
          label: "Yes"
        },
        {
          value: "2",
          label: "No"
        }
      ]
    }
  ];

  const defaultValues = {
    print_date: pd ?? printDate(new Date()),
    print_pad_type: "1"
  };

  const onSubmit = (data) => {
    handlePrint(data);
    toggle();
  };

  const isLoading = false;

  const title = modalTitle;

  return (
    <Modal modal={modal} toggle={toggle} title={title}>
      <Form
        fields={fields}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
        submitbtnText={"Print"}
        toggle={toggle}
        loading={typeof isLoading === "boolean" ? isLoading : undefined}
      />
    </Modal>
  );
}
